import { render, staticRenderFns } from "./list_pc.vue?vue&type=template&id=653d7a52&scoped=true&"
import script from "./list_pc.vue?vue&type=script&lang=js&"
export * from "./list_pc.vue?vue&type=script&lang=js&"
import style0 from "./list_pc.vue?vue&type=style&index=0&id=653d7a52&lang=less&scoped=true&"
import style1 from "./list_pc.vue?vue&type=style&index=1&id=653d7a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d7a52",
  null
  
)

export default component.exports